<div class="state-selected" [class.mobile]="onMobileView === true">
  <h4>Ausgewählt: Österreich {{breadcrumbString}}</h4>
  <div class="breadcrumbs-wrapper" [class.equally-distributed]="onMobileView && breadcrumbs.length >= 5">
    <ng-container *ngIf="breadcrumbs.length != 0">
      <app-search-cell [styleMode]="'darkBackground'"
                       [custom]="{name: 'Österreich', image: 'assets/images/austria.png'}"
                       (click)="goBack(null)">  </app-search-cell>
    </ng-container>

    <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
      <ng-container *ngIf="breadcrumbs.length > i + 1; else lastCell">
        <app-search-cell [styleMode]="'darkBackground'"
                         [custom]="{name: breadcrumb.name, image: breadcrumb.image}"
                         (click)="goBack(breadcrumb)"></app-search-cell>
      </ng-container>
      <ng-template #lastCell>
        <app-search-cell [styleMode]="'darkBackground'" [custom]="{name: breadcrumb.name, image: breadcrumb.image}"></app-search-cell>
      </ng-template>
    </ng-container>
  </div>

  <h4>Alle Ligen von {{name}}</h4>
  <div class="boxes" *ngIf="selectedSex == null; else showLeagues">
    <app-search-cell *ngFor="let sex of sexes" [custom]="{name: sex.germanString, image: sex.icon}" (click)="sexClicked(sex)"></app-search-cell>
  </div>
  <ng-template #showLeagues>
    <div class="boxes" [class.equally-distributed]="onMobileView && mainAndUpperLeagues.length >= 5" *ngIf="loading === false && mainAndUpperLeagues != null && mainAndUpperLeagues.length > 0; else noLeaguesAvailable">
      <app-search-cell *ngFor="let league of mainAndUpperLeagues" [league]="league" (click)="leagueClicked(league)"></app-search-cell>
    </div>
  </ng-template>

  <ng-template #noLeaguesAvailable>
    <p class="no-infos-available">
      Keine Ligen vorhanden
    </p>
  </ng-template>
</div>
